/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/img-handle/img-handle');
require('components/base/pop/pop');

const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { time } = require('src/common/utils/date');
const { apiPath } = require('appService/api');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');

require('./car-vertify.scss');
const template = require('./car-vertify.tpl');

const CarVertify = {
	name: "car-vertify",

	template,

  store,

	data() {
		return {
			thItems: ["序号", "用户名", "手机号", "品牌", "车系", "具体车型", "认证类型", "认证提交时间", "认证状态", "操作"],
			url: apiPath.user.carVertify,
			vertifyBrand: [],
			placeItem: '输入用户名',
			queryTime: {
        beginTime: '',
        endTime: '',
      },
      vertifyType: {
        "0": "购车发票认证",
        "1": "行驶证认证"
      },
      vertifyState: {
      	"1": "已认证",
      	"-1": "待认证",
      	"-2": "已驳回"
      },
      vertifyMessage: {},
      vertifyHead: '',
      vertifyTip: '',
      vertifyIndex: '',
      vertifyItem: '',
      rejectReason: '',
      now: time(new Date().getTime()),
		}
	},

	ready() {
		this.queryVertifyBrand();
	},

	methods: {
    formatTime(time, hasNoHM){
      let dTime = new Date(time),
          dMinutes = dTime.getMinutes();
          dMinutes = dMinutes< 10 ? "0"+ dMinutes : dMinutes;
      return ( hasNoHM ? `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}  ${dTime.getHours()}:${dMinutes}` : `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}`);
    },
    formatQueryTime(val){
      if (val){
        let dTime = new Date();
        this.queryTime.endTime = this.formatTime(this.now);
        this.queryTime.beginTime = this.formatTime(dTime.setDate(dTime.getDate() - parseInt(val)));
      } 
    },
		queryVertifyBrand() {
      let url = apiPath.user.vertifyBrand;
      this.vertifyBrand.push({
        text: '选择品牌',
        value: -1
      })
      ajaxHttp(url).then((res) => {
        res.data.forEach((item, index) => {
          this.vertifyBrand.push({
            text: item.vertifyBrand,
            value: item.brandId
          })
        })
      }).catch((res) => {
        tip(res.error)
      });
    },
    qurryCarVertify() {
    	let queryParams = {
        vertifyState: this.$refs.vertifyDropmenu.val(),
        vertifyBrand: this.$refs.brandDropmenu.val(),
        beginTime: this.queryTime.beginTime,
        endTime: this.queryTime.endTime,
        keyType: this.$refs.ktypeDropmenu.val(),
        keyWord: this.$refs.kwordInputbox.val()
      };
    	this.$refs.tableData.query(queryParams).fetch();
    },
    showVertifyDetail(index) {
      this.vertifyIndex = index;
    	this.$refs.vermessagePop.show();
    	let queryParams = {
    		id: this.$refs.tableData.trItems[index].id
    	}
    	ajaxHttp(apiPath.user.queryVertifyMessage, {
    		"data": queryParams
    	}).then((res) => {
    		this.vertifyMessage = res.data;
    	}).catch((res) => {
        tip(res.error);
    	});
    },
    updateCarVertify(item) {
      this.vertifyItem = item;
      this.$refs.reasonInput.val('');
      if( item === -3 ) {
        this.$refs.vertifyPop.show();
        this.vertifyHead = "取消认证";
        this.vertifyTip = "请输入取消理由"
      } else if( item === -2 ) {
        this.$refs.vertifyPop.show();
        this.vertifyHead = "驳回";
        this.vertifyTip = "请输入驳回理由"
      } else if( item === 1 ) {
        this.changeVertifyState();
      }
    },
    changeVertifyState() {
      let url = apiPath.user.updateCarVertify;
      if(this.vertifyItem !== 1 && !this.$refs.reasonInput.val()) {
        tip("请输入理由！");
      } else {
        let inputLen = (this.$refs.reasonInput.val()).toString().length;
        if(inputLen > 120) {
          tip("输入内容不能超过120个字符！");
        } else {
          let queryParams = {
            reason: this.$refs.reasonInput.val(),
            status: this.vertifyItem,
            id: this.$refs.tableData.trItems[this.vertifyIndex].id
          }
          ajaxHttp(url, {
            "type": "post",
            "data": queryParams
          }).then((res) => {
            this.$refs.tableData.trItems[this.vertifyIndex].vertifyState = res.data.vertifyState;
            this.$refs.tableData.trItems[this.vertifyIndex].reason = res.data.reason;
            if(this.vertifyItem === 1) {
              this.$refs.vermessagePop.hide();
              tip("已通过该认证！");
            } else if(this.vertifyItem === -2) {
              this.$refs.vertifyPop.hide();
              this.$refs.vermessagePop.hide();
              tip("已驳回该认证！");
            } else if(this.vertifyItem === -3) {
              this.$refs.vertifyPop.hide();
              this.$refs.vermessagePop.hide();
              tip("已取消该认证！");
            }
          }).catch((res) => {
            tip(res.error);
          });
        }
      }
    },
    showRejectReason(index) {
      this.$refs.rejectreasonPop.show();
      this.rejectReason = this.$refs.tableData.trItems[index].reason;
    }
	},

	events: {
		[dropMenuEvent.menu.change](){
			if ( this.$refs.ktypeDropmenu.val() === 1) {
				this.placeItem = "输入用户名"
			} else if ( this.$refs.ktypeDropmenu.val() === 2 ) {
				this.placeItem = "输入手机号"
			}
		}
	},

	filters: {
    changeVerType(value) {
      return this.vertifyType[value];
    },
		changeVertify(value) {
			return this.vertifyState[value];
		},
    checkEmpty(value) {
      if(!value) {
        value = "--";
      }
      return value;
    }
	}
}

module.exports = CarVertify;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/user/car-vertify/car-vertify.js